export const getCustomisationEntityAri = (cloudId?: string, activationId?: string | null) =>
  cloudId && activationId && `ari:cloud:townsquare:${cloudId}:workspace/${activationId}`;
